module.exports = __webpack_public_path__ + "static/img/rank_281.4b0c0da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_281.png
// module id = Z3I/
// module chunks = 1